import React from 'react';
import  ReactDOM  from 'react-dom';

import App from './App';
import './index.css';

// Rendering to index.html div with id of root
ReactDOM.render(<App />, document.getElementById('root'));